import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Activity, ExternalLink } from 'lucide-react';
import { Button } from '../ui/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Features',
    path: '/features'
  }, {
    name: 'Pricing',
    path: '/pricing'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Resources',
    path: '/resources'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isActive = (path: string) => {
    return location.pathname === path ? 'text-cyan-400' : 'text-slate-300 hover:text-white';
  };
  return <header className="fixed top-0 left-0 right-0 z-50 bg-slate-950/80 backdrop-blur-md border-b border-slate-800" data-id="element-61">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <div className="flex items-center justify-between h-16" data-id="element-63">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2" data-id="element-64">
            <Activity className="h-8 w-8 text-cyan-500" data-id="element-65" />
            <span className="text-xl font-bold text-white tracking-tight" data-id="element-66">
              njgod
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-67">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors ${isActive(link.path)}`} data-id="element-68">
                {link.name}
              </Link>)}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center space-x-4" data-id="element-69">
            <a href="https://app.njgod.com" target="_blank" rel="noopener noreferrer" data-id="element-70">
              <Button variant="primary" size="sm" rightIcon={<ExternalLink className="h-4 w-4" data-id="element-72" />} data-id="element-71">
                Login to App
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-73">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-slate-300 hover:text-white p-2" aria-label="Toggle menu" data-id="element-74">
              {isMenuOpen ? <X className="h-6 w-6" data-id="element-75" /> : <Menu className="h-6 w-6" data-id="element-76" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-slate-950 border-b border-slate-800" data-id="element-77">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-78">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`block px-3 py-2 rounded-md text-base font-medium ${location.pathname === link.path ? 'bg-slate-900 text-cyan-400' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`} onClick={() => setIsMenuOpen(false)} data-id="element-79">
                {link.name}
              </Link>)}
            <div className="pt-4 pb-2" data-id="element-80">
              <a href="https://app.njgod.com" target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-81">
                <Button variant="primary" className="w-full justify-center" data-id="element-82">
                  Login to App
                </Button>
              </a>
            </div>
          </div>
        </div>}
    </header>;
}